import client from "./client";
import { AdminPunchException } from "../interfaces/PunchExceptions";

export function getPunchExceptionsErrorMessage(err: unknown): string {
  if (err && typeof err === "object" && "response" in err) {
    const response = (err as { response?: { data?: { error?: string; message?: string } } }).response;
    if (response?.data?.error) return response.data.error;
    if (response?.data?.message) return response.data.message;
  }

  if (err instanceof Error) return err.message;
  return "An error occurred while loading GPS exceptions.";
}

export async function getPunchExceptions(payPeriodID: number): Promise<AdminPunchException[]> {
  const response = await client.get<{ exceptions: AdminPunchException[] }>("admin/punchExceptions", {
    params: { payPeriodID },
  });
  return response.data.exceptions;
}

/** Response of PATCH /admin/punchExceptions/:id/review — the row's fresh review state. */
export interface PunchExceptionReviewResult {
  punchExceptionID: number;
  reviewed: boolean;
  reviewedByAdminEmployeeID: number | null;
  reviewedByName: string | null;
  reviewedAt: string | null;
  reviewNote: string | null;
}

/** Message extractor for the review PATCH, mirroring getPunchExceptionsErrorMessage. */
export function setPunchExceptionReviewedErrorMessage(err: unknown): string {
  if (err && typeof err === "object" && "response" in err) {
    const response = (err as { response?: { data?: { error?: string; message?: string } } }).response;
    if (response?.data?.error) return response.data.error;
    if (response?.data?.message) return response.data.message;
  }

  if (err instanceof Error) return err.message;
  return "An error occurred while updating the review state.";
}

/**
 * PATCH /admin/punchExceptions/:id/review — mark an exception reviewed (optionally
 * with a note) or clear the review state (reviewed=false clears reviewer/timestamp/note).
 * Returns the row's fresh review state.
 */
export async function setPunchExceptionReviewed(
  punchExceptionID: number,
  reviewed: boolean,
  note?: string | null,
): Promise<PunchExceptionReviewResult> {
  const response = await client.patch<PunchExceptionReviewResult>(
    `admin/punchExceptions/${punchExceptionID}/review`,
    { reviewed, note },
  );
  return response.data;
}
